import React from 'react'
import {Loader} from 'components'
import {
    Response,
    NewProduct,
    TBCConnect,
    CommunicationPoll,
    OfferPrice,
    BuyPromotion,
    ProveLoan,
    MessageToUser,
    LoginRequired,
    SecurityFishing,
    TbcCreditForm,
    CreateDiscount,
    ImageSearch,
    NewAddress,
    KnowMore,
    PhoneVerification,
    TransactionDetails,
    Confirmation,
    Payment,
    SecurityCode,
    InvoiceForm,
    FlexiblePackage,
    PasswordCheck,
    InfoUsageAgreement,
    ReturnItem,
    Feedback,
    ProductStats,
    BlockedReason,
    PhoneConfirmation,
    ProductDateInfo,
    ProductSort,
    FeedbackOnline,
    NotificationText,
    AddAccountNumber,
    ReminderOnline,
    AddReview,
    ConcurentionAgancy,
    ReturnConditionsModal,
    NewAccount,
    PhotoMobile,
    AddCard,
    CardDeleteWarning,
    Warning,
    CardPlatforms,
    PaymentOptions,
    StatusesChange,
    // RTransactionDetails,
    Deactivation,
    // RTransactionDetails, 
    // RBlockedReason,
    // RPhoneConfirmation,
    // RAddReview,
    // RLoanReBank,
    // RInstallmentForm
} from 'components/modals';
import SelfTakeoutConfirmModal from './components/SelfTakeoutConfirmModal';
import Analytics from './components/analytics/Analytics';
import PromotionCheckoutModal from './components/PromotionCheckoutModal';
import FlashSalesModal from './components/FlashSalesModal';
import ProfileEditIframeModal from './components/ProfileEditIframeModal';
import TwoHourDeliveryModal from './components/TwoHourDeliveryModal';
import PromPackagesSaleModal from './components/PromPackagesSaleModal';
import PaymentModal from './components/pay-flow/PaymentModal';
import TbcDistributionModal from './components/TbcDistributionModal';
import TbcBnplModal from './components/TbcBnplModal';

const Component = (props) => {
    // console.log(props)
    const modalsList = [
        {Name: 'Response',Component: Response},
        {Name: 'NewProduct',Component: NewProduct},
        {Name: 'TBCConnect',Component: TBCConnect},
        {Name: 'CommunicationPoll',Component: CommunicationPoll},
        {Name: 'OfferPrice',Component: OfferPrice},
        {Name: 'BuyPromotion',Component: BuyPromotion},
        {Name: 'PromotionCheckoutModal', Component: PromotionCheckoutModal},
        {Name: 'ProveLoan',Component: ProveLoan},
        {Name: 'MessageToUser',Component: MessageToUser},
        {Name: 'LoginRequired',Component: LoginRequired},
        {Name: 'SecurityFishing',Component: SecurityFishing},
        {Name: 'TbcCreditForm',Component: TbcCreditForm},
        {Name: 'CreateDiscount',Component: CreateDiscount},
        {Name: 'ImageSearch',Component: ImageSearch},
        {Name: 'NewAddress',Component: NewAddress},
        {Name: 'KnowMore',Component: KnowMore},
        {Name: 'PhoneVerification',Component: PhoneVerification},
        {Name: 'TransactionDetails',Component: TransactionDetails},
        {Name: 'ConcurentionAgancy',Component:ConcurentionAgancy},
        {Name: 'ReturnConditionsModal',Component:ReturnConditionsModal},
        {Name: 'Confirmation',Component: Confirmation},
        {Name: 'Payment',Component: Payment},
        {Name: 'SecurityCode',Component: SecurityCode},
        {Name: 'InvoiceForm',Component: InvoiceForm},
        {Name: 'FlexiblePackage',Component: FlexiblePackage},
        {Name: 'PasswordCheck',Component: PasswordCheck},
        {Name: 'InfoUsageAgreement',Component: InfoUsageAgreement},
        {Name: 'ReturnItem',Component: ReturnItem},
        {Name: 'Feedback',Component: Feedback},
        {Name: 'ProductStats',Component: ProductStats},
        {Name: 'BlockedReason',Component: BlockedReason},
        {Name: 'PhoneConfirmation',Component: PhoneConfirmation},
        {Name: 'ProductDateInfo', Component: ProductDateInfo},
        {Name: 'ProductSort', Component: ProductSort},
        {Name: 'FeedbackOnline',Component: FeedbackOnline},
        {Name: 'NotificationText',Component: NotificationText},
        {Name: 'AddAccountNumber',Component: AddAccountNumber},
        {Name: 'ReminderOnline',Component:ReminderOnline},
        {Name: 'ConcurentionAgancy',Component:ConcurentionAgancy},
        {Name: 'ReturnConditionsModal',Component:ReturnConditionsModal},
        {Name: 'NewAccount', Component: NewAccount},
        {Name: 'PhotoMobile', Component: PhotoMobile},
        {Name: 'AddCard', Component: AddCard},
        {Name: 'PaymentOptions', Component: PaymentOptions},
        // {Name: 'TransactionDetails',Component: RTransactionDetails},W
        // {Name: 'BlockedReason',Component: RBlockedReason},
        // {Name: 'PhoneConfirmation',Component: RPhoneConfirmation},
        // {Name: 'CreateDiscount',Component: RCreateDiscount},
        {Name: 'AddReview',Component: AddReview},
        {Name: 'CardDeleteWarning',Component: CardDeleteWarning},
        {Name: 'Warning',Component: Warning},
        {Name: 'CardPlatforms',Component: CardPlatforms},
        {Name: 'Deactivation',Component: Deactivation},
        {Name: 'StatusesChange',Component: StatusesChange},
        {Name: 'SelfTakeoutConfirmModal', Component: SelfTakeoutConfirmModal },
        {Name: 'FlashSalesModal', Component: FlashSalesModal},
        {Name: 'TwoHourDeliveryModal', Component: TwoHourDeliveryModal},
        {Name: 'TbcDistributionModal', Component: TbcDistributionModal},
        {Name: 'TbcBnplModal', Component: TbcBnplModal},
        {Name: 'Analytics', Component: Analytics},
        {Name: 'ProfileEditIframeModal', Component: ProfileEditIframeModal},
        {Name: 'PromPackagesSaleModal', Component: PromPackagesSaleModal},
        // {Name: 'OfferPrice',Component: ROfferPrice},
        // {Name: 'LoanReBank',Component: RLoanReBank},
        // {Name: 'InstallmentForm',Component: RInstallmentForm},
        {Name: 'PaymentModal',Component: PaymentModal},
    ]
    let Modal = modalsList.find(o => o.Name === props.component)?.Component
    return (Modal && !props.modalLoading) ? <Modal {...props} /> : <Loader/>
}
export default Component
